
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";
import AppAccountingStock from "@/components/settings-default/AccountingStock.vue";
import AppStockScanner from "@/components/settings-default/StockScanner.vue";
import AppSizeTableSettings from "@/components/settings-default/SizeTableSettings.vue";
import { AddToAutomaticOrderToSupplier, StockLocationSettings } from "@/models/dossier-configs/stock-location-settings";
import { getEnumValueFromKey } from "@/utils/enum";
import { AuthService } from "@/services";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data() {
		return {
			config: DossierConfigService.getStockLocationConfig(),
			toEditLocationID: 0 as number,
			toEditAlias: "",
			toEditSettings: new StockLocationSettings()
		};
	},
	computed: {
		configCount: () => StockLocationConfig.MAX_ID,
		hasSizeModule():boolean {
			return AuthService.hasModule(MODULE.MATENTABEL);
		},
		path():IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/products", value: this.$ct("products")},
				{
					value: this.$ct("stock")
				}
			] as IBreadCrumb[];
		},
		locationIDs():number[] {
			let nums = [];
			for (let i = 1; i <= this.configCount; i++) {
				nums.push(i);
			}
			return nums;
		},
		saveEnabled():boolean {
			if (this.toEditAlias == "") {
				return true;
			}
			if (this.toEditAlias.match(/^\s*$/)) {
				return false;
			}
			return true;
		},
		addToAutomaticOrderSupplierOptions():ISelectItem<AddToAutomaticOrderToSupplier>[]{
			let keys:(keyof AddToAutomaticOrderToSupplier)[] = [
				"DISABLED",
				"ADD",
				"SUBTRACT"
			] as any[];
			return keys.map(k=>{
				return {
					text: this.$ct(`add-to-automatic-order-to-supplier-options.${k}`),
					value: getEnumValueFromKey(AddToAutomaticOrderToSupplier, k)
				};
			});
		}
	},
	methods: {
		editLocation(id:number) {
			this.toEditLocationID = id;
			this.toEditAlias = this.config.getLocationAlias(id);
			this.toEditSettings = this.config.getLocationSettings(id);
		},
		async saveEdit() {
			this.config.setLocationAlias(this.toEditLocationID, this.toEditAlias);
			this.config.setLocationSettings(this.toEditLocationID, this.toEditSettings);
			try {
				this.config = await DossierConfigService.saveStockLocationConfig(this.config);
				this.toEditLocationID = 0;
			} catch(err) {
				this.$wf.notify("ERROR", "danger", 3000, "exclamation-triangle");
			}
		},
		cancelEdit() {
			this.toEditLocationID = 0;
		}
	},
	components: {
		AppAccountingStock,
		AppStockScanner,
		AppSizeTableSettings
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
